// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes timer-pulse-33a8d4ae{0%{box-shadow:0 0 0 0 rgba(122,204,51,.6)}70%{box-shadow:0 0 0 10px rgba(204,169,44,0)}to{box-shadow:0 0 0 0 rgba(204,169,44,0)}}.card-header[data-v-33a8d4ae]{border-bottom:1px solid #d3d8d9;box-shadow:none;display:flex;justify-content:space-between;padding-bottom:24px}.card-header .inner[data-v-33a8d4ae]{align-items:center;display:flex}.card-header .s-cross[data-v-33a8d4ae]{cursor:pointer;margin-right:19px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
